import React, { useEffect, useRef } from "react";
import { FaTimes, FaUserPlus } from "react-icons/fa";
import "./AccountNotFoundDialog.css";

export default function AccountNotFoundDialog({ isOpen, onClose, onConfirm }) {
  const modalRef = useRef(null);
  const confirmButtonRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    // Focus the confirm button when the dialog opens
    if (confirmButtonRef.current) {
      confirmButtonRef.current.focus();
    }

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }

      // Simple focus trap: Tab and Shift+Tab loop inside dialog controls
      if (e.key === "Tab" && modalRef.current) {
        const focusableElements = modalRef.current.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="anf-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="anf-title" aria-describedby="anf-desc">
      <div
        className="anf-modal-box"
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
      >
        <button
          className="anf-modal-close"
          onClick={onClose}
          aria-label="Close dialog"
        >
          <FaTimes />
        </button>

        <div className="anf-content">
          <div className="anf-icon-container">
            <FaUserPlus className="anf-warning-icon" />
          </div>
          
          <h2 id="anf-title" className="anf-title">
            Account Not Found
          </h2>
          
          <p id="anf-desc" className="anf-description">
            We couldn't find an account matching that email address. Would you like to create a new MarsMate AI account now?
          </p>

          <div className="anf-actions">
            <button
              ref={confirmButtonRef}
              className="anf-btn-primary"
              onClick={onConfirm}
            >
              Sign Up Now
            </button>
            <button
              className="anf-btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
